import { EventEmitter } from '@angular/core';
import { INavItem } from '@bssh/comp-lib';
import { GenomeStatus, ReferenceFileStatus } from '@stratus/gss-ng-sdk';

export const REFERENCE_RESOURCE_STATUS_MAP = (status: string): string => {
  switch (status) {
    case GenomeStatus.ACTIVE:
    case ReferenceFileStatus.READY:
      return 'Active';
    case GenomeStatus.INACTIVE: return 'Inactive';
    case GenomeStatus.RELEASE_FAILED:
    case ReferenceFileStatus.RELEASE_FAILED:
      return 'Release Failed';
    case GenomeStatus.RELEASE_IN_PROGRESS:
    case ReferenceFileStatus.RELEASE_IN_PROGRESS:
      return 'Release In Progress';
    default: return 'Unknown';
  }
}

interface IMenuItem extends INavItem {
  visible: boolean
}

export enum ResourcesPath {
  LibraryPrepKits = 'library-prep-kits',
  IndexAdapterKits = 'index-adapter-kits',
  PrepTabKits = 'prep-tab-kits',
  Genomes = 'genomes',
  ReferenceFiles = 'reference-files',
  AnalysisConfigurationTemplate = 'analysis-configuration-templates',
  AnalysisConfigurationTemplateEdit = 'analysis-configuration-templates/edit',
  AnalysisDefinitions = 'analysis-definitions',
  CreateNew = 'create'
}

export const GetResourcesRoute = (resourcesPath: string) => `/resources/${resourcesPath}`;

export const ResourcesMenuItems: IMenuItem[] = [
  { label: 'Library Prep Kits', route: [ResourcesPath.LibraryPrepKits], disabled: false, visible: true },
  { label: 'Index Adapter Kits', route: [ResourcesPath.IndexAdapterKits], disabled: false, visible: true },
  { label: 'Prep Tab Kits', route: [ResourcesPath.PrepTabKits], disabled: false, visible: true },
  { label: 'Reference Files', route: [ResourcesPath.ReferenceFiles], disabled: false, visible: false },
  { label: 'Genomes', route: [ResourcesPath.Genomes], disabled: false, visible: true },
  { label: 'Analysis Configuration Templates', route: [ResourcesPath.AnalysisConfigurationTemplate], disabled: false, visible: false },
  { label: 'Analysis Definitions', route: [ResourcesPath.AnalysisDefinitions], disabled: false, visible: true }
];

export interface IResourcesPageComponent {
  isNewButtonAvailable: boolean;
  newButtonText?: string;
  newButtonActionEventEmitter?: EventEmitter<void>;
  newButtonOpensMenu?: boolean;
  newButtonMenuItems?: INewResourceMenuItem[];
}

export const TimeoutValue: number = 60000 * 3;

export enum context {
  EDIT,
}

export interface INewResourceMenuItem {
  label: string;
  dataCy: string;
  action: (event: any) => void;
}

export enum ReferenceFileQueryParams {
  BsshFileId = 'bsshFileId',
  BsshFileName = 'bsshFileName',
  BsshFileSizeInBytes = 'bsshFileSizeInBytes',
}